import { ActiveDevice } from '../config.type';

export enum PISPDepositStatusEnum {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PENDING = 'pending',
}

export type PispDepositFlowRedirectionConfig = {
  [key in ActiveDevice]: { [key in PISPDepositStatusEnum]: string };
};

export const defaultPispDepositFlowRedirectionConfig: PispDepositFlowRedirectionConfig = {
  [ActiveDevice.MOBILE]: {
    [PISPDepositStatusEnum.COMPLETED]: '/zones/payments/deposit-success-failed',
    [PISPDepositStatusEnum.FAILED]: '/zones/payments/deposit-success-failed',
    [PISPDepositStatusEnum.PENDING]: '/zones/payments/deposit-success-failed',
  },
  [ActiveDevice.TABLET]: {
    [PISPDepositStatusEnum.COMPLETED]: '/zones/payments/deposit-success-failed',
    [PISPDepositStatusEnum.FAILED]: '/zones/payments/deposit-success-failed',
    [PISPDepositStatusEnum.PENDING]: '/zones/payments/deposit-success-failed',
  },
  [ActiveDevice.DESKTOP]: {
    [PISPDepositStatusEnum.COMPLETED]: '/zones/payments/deposit-success-failed',
    [PISPDepositStatusEnum.FAILED]: '/zones/payments/deposit-success-failed',
    [PISPDepositStatusEnum.PENDING]: '/zones/payments/deposit-success-failed',
  },
};
